import React from 'react'
import { Table, Row, Col } from 'reactstrap';
import AddUserButton from '../AddUserButton/AddUserButton';
import editImg from '../../../images/edit2.png'
import './index.css'
import { useLocation } from 'react-router-dom';

const CommonCompetition = ({ handleAddSegment, handleAddCompany, handleEditSegment, handleEditCompany, totalSegmentTurnOver, totalCompanyTurnOver, segmentData, companyData }) => {

    const location = useLocation();

    return (
        <div id='commonCompetition'>
            <Row>
                <Col lg={6}>
                    <div className='tableBlock text-center'>
                        <div className='dealerRegBlocktitle title2 '>
                            Input Wise Last Year Turnover
                        </div>
                        {segmentData && segmentData.length > 0 ? (
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th>Segment Name</th>
                                        <th>Financial Year</th>
                                        <th>Turnover (Lakhs)</th>
                                        {location && (location.pathname.includes('/pages/business-competition-insights') || location.pathname.includes('/pages/kyc')) ? <th>Action</th> : ''}
                                    </tr>
                                </thead>
                                <tbody>
                                    {segmentData.map((row, i) => {
                                        return (
                                            <tr key={i}>
                                                <td>{row.segment}</td>
                                                <td>{row.year}</td>
                                                <td>{(row.turnover / 100000).toFixed(2)}</td>
                                                {location && (location.pathname.includes('/pages/business-competition-insights') || location.pathname.includes('/pages/kyc')) ?
                                                    <td>
                                                        <div className='d-flex align-items-center justify-content-center'>
                                                            <img
                                                                onClick={() => handleEditSegment(row, 1)}
                                                                src={editImg}
                                                                className='iconImg cursorPointer'
                                                                alt='editIcon'
                                                            />
                                                        </div>
                                                    </td>
                                                    : ''}
                                            </tr>
                                        );
                                    })}
                                    <tr>
                                        <td style={{ fontWeight: '700' }}>Total</td>
                                        <td>&nbsp;</td>
                                        <td style={{ fontWeight: '700' }}>
                                            {(
                                                totalSegmentTurnOver.reduce((a, b) => a + b, 0) /
                                                100000
                                            ).toFixed(2)}
                                        </td>
                                        <td>&nbsp;</td>
                                    </tr>
                                </tbody>
                            </Table>
                        ) : ''}
                        {location && (location.pathname.includes('/pages/business-competition-insights') || location.pathname.includes('/pages/kyc')) ? (
                            segmentData && segmentData.length < 5 ? (
                                <div className='justify-content-center'>
                                    <div className='addUserBtnBlock d-flex flex-wrap justify-content-center'>
                                        <AddUserButton customClass='pt-0' onClick={(e) => handleAddSegment(e, 2)} name={'Add Input'} />
                                    </div>
                                </div>
                            ) : ''
                        ) : ''}

                    </div>
                </Col>
                <Col lg={6}>
                    <div className='tableBlock text-center'>
                        <div className='dealerRegBlocktitle title2 '>
                            Company Wise Last Year Turnover
                        </div>
                        {companyData && companyData.length > 0 ? (
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th>Company Name</th>
                                        <th>Financial Year</th>
                                        <th>Turnover (Lakhs)</th>
                                        {location && (location.pathname.includes('/pages/business-competition-insights') || location.pathname.includes('/pages/kyc')) ? <th>Action</th> : ''}
                                    </tr>
                                </thead>
                                <tbody>
                                    {companyData.map((row, i) => {
                                        return (
                                            <tr key={i}>
                                                <td>{row.company_name}</td>
                                                <td>{row.year}</td>
                                                <td>{(row.turnover / 100000).toFixed(2)}</td>
                                                {location && (location.pathname.includes('/pages/business-competition-insights') || location.pathname.includes('/pages/kyc')) ? <td>
                                                    <div className='d-flex align-items-center justify-content-center'>
                                                        <img onClick={() => handleEditCompany(row, 4)} src={editImg} alt='editImg' className='iconImg cursorPointer' />
                                                    </div>
                                                </td> : ''}
                                            </tr>
                                        );
                                    })}
                                    <tr>
                                        <td style={{ fontWeight: '700' }}>Total</td>
                                        <td>&nbsp;</td>
                                        <td style={{ fontWeight: '700' }}>
                                            {(
                                                totalCompanyTurnOver.reduce((a, b) => a + b, 0) /
                                                100000
                                            ).toFixed(2)}
                                        </td>
                                        <td>&nbsp;</td>
                                    </tr>
                                </tbody>
                            </Table>
                        ) : ''}
                        {location && (location.pathname.includes('/pages/business-competition-insights') || location.pathname.includes('/pages/kyc')) ?
                            <div className='justify-content-center'>
                                <div className='addUserBtnBlock d-flex flex-wrap justify-content-center'>
                                    <AddUserButton customClass='pt-0' onClick={(e) => handleAddCompany(e, 3)} name={'Add Company'} />
                                </div>
                            </div>
                            : ''}
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default CommonCompetition
